// Placeholder identities used by tests, headless scripts, and the dev boot
// until onboarding (M3) creates real players.

import type { NewPlayerInput, Origin } from "./player";
import { avatarFromPfp, type BodyType } from "./avatar/traits";
import { generatePfpTraits, rarityOf } from "./pfp/traits";

export function presetPlayer(origin: Origin = "novice", body: BodyType = "anon", seed = 4021): NewPlayerInput {
  const traits = generatePfpTraits(seed);
  return {
    name: origin === "kol" ? "0xBigBags" : "ChartSensei",
    handle: origin === "kol" ? "0xbigbags" : "chartsensei",
    bio: "Not financial advice. Barely advice.",
    pfp: { seed, traits, rarity: rarityOf(traits).tier },
    avatar: avatarFromPfp(traits, body, seed),
    origin,
  };
}
